import React from 'react'
import strings from 'utils/strings'
import styled from '@emotion/styled'
import { LIST, DASH_VIEW } from 'utils/constants'
import { useDispatch } from 'react-redux'
import { resetVehicleDash } from 'actions/dash'
import { setSelectedIdWithDrawerAndMeta } from 'actions/navigator'
import { Content, Footer } from 'components/SwitchAndGauge/DashDrawer/Sections'
import { Button, Paragraph, FlexRow, FlexCol } from 'components/patterns'
import { StyledViewWrap } from './style'

const ResetView = () => {
  const dispatch = useDispatch()

  const handleOnCancel = () => {
    dispatch(
      setSelectedIdWithDrawerAndMeta(DASH_VIEW, {
        view: LIST,
      })
    )
  }

  const handleOnConfirmReset = () => {
    dispatch(resetVehicleDash())
    dispatch(
      setSelectedIdWithDrawerAndMeta(DASH_VIEW, {
        view: LIST,
      })
    )
  }

  return (
    <StyledViewWrap>
      <Content style={{ marginTop: 15, height: 'auto', overflowY: 'hidden' }}>
        <StyledResetRow>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={22}
            height={18}
            fill="none"
            style={{ marginRight: 8, position: 'relative', top: 3 }}
          >
            <path
              fill="#4F5764"
              fillOpacity={0.87}
              fillRule="evenodd"
              d="M19.71 14.82 11.84 1.06a2.09 2.09 0 0 0-3.63 0L.31 14.82A2.12 2.12 0 0 0 2.1 18h15.8a2.12 2.12 0 0 0 1.81-3.18zM11 14.5H9v-2h2v2zm0-5a1 1 0 0 1-2 0v-2a1 1 0 0 1 2 0v2z"
              clipRule="evenodd"
            />
          </svg>

          <StyledResetColumn>
            <StyledParagraphOne size="large" weight="bold">
              {strings.resetting_switch_and_gauge}
            </StyledParagraphOne>
            <StyledParagraphTwo>
              {strings.reset_will_clearP_all_unsaved_changes}
            </StyledParagraphTwo>
          </StyledResetColumn>
        </StyledResetRow>
      </Content>
      <Footer>
        <FlexRow>
          <FlexCol span={12}>
            <div>
              <Button type="secondary" onClick={handleOnCancel}>
                {strings.cancel}
              </Button>
            </div>
          </FlexCol>
          <FlexCol span={12} alignItems="end">
            <div>
              <Button type="danger" onClick={handleOnConfirmReset}>
                {strings.reset}
              </Button>
            </div>
          </FlexCol>
        </FlexRow>
      </Footer>
    </StyledViewWrap>
  )
}

export default ResetView

const StyledParagraphOne = styled(Paragraph)`
  font-size: 20px;
  margin-bottom: 7%;
`

const StyledParagraphTwo = styled(Paragraph)`
  margin-bottom: 3%;
  max-width: 350px;
`

const StyledResetRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 10%;
`
const StyledResetColumn = styled.div`
  order: 2;
  display: flex;
  flex-direction: column;
`
